<template>
  <div class="appFooter">
    <!-- Profile -->
    <div class="appFooter__profile">
      <router-link :to="{ name: 'profile' }">
        <el-link :underline="false">
          <div class="appFooter__profile--circle">
            <i class="el-icon-user el-icon--left"></i>
            {{ customer.first_name }} {{ customer.last_name }}
          </div>
        </el-link>
      </router-link>
    </div>
    <!-- Records -->
    <div class="appFooter__records">
      <router-link :to="{ name: 'records-grid' }">
        <el-link :underline="false">
          <div class="appFooter__profile--circle">
            <i class="el-icon-files el-icon--left"></i>
            {{ $t('nav.records') }}
          </div>
        </el-link>
      </router-link>
    </div>
    <div class="appFooter__links">
      <el-link
        :underline="false"
        class="appFooter__links--contact"
        href="mailto:connexion-ibail@arpej.fr"
      >{{ $t('footer.contact') }}</el-link>
      <el-link
        :underline="false"
        target="_blank"
        class="appFooter__links--cgu"
        :href="$t('footer.cguLink')"
      >{{ $t('footer.legal') }}</el-link>
    </div>
    <div class="appFooter__copyright">Arpej {{ new Date().getFullYear() }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppFooter',
  computed: {
    ...mapState({
      customer: state => state.customer
    })
  }
}
</script>

<style lang="scss" scoped>
$c: '.appFooter';

#{$c} {
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #2d2d2d;
  color: #ffffff;
  padding: 0 $--base-padding;

  a {
    color: #ffffff;
  }

  .el-link {
    font-size: 14px;
  }

  &__links {
    font-size: 14px;
    @include respond-below(md) {
      display: none;
    }

    &--contact {
      height: 41px;
      width: 164px;
      border: 1px solid #e4e4e4;
      border-radius: 20px;
      margin-right: 50px;
    }
    &--cgu {
      text-decoration: underline;
    }
  }

  &__copyright {
    @include respond-below(md) {
      display: none;
    }
  }

  &__profile,
  &__records {
    &--circle {
      display: flex;
      flex-direction: column;
      margin-top: -30px;
      text-align: center;
    }
    .el-icon-user,
    .el-icon-files {
      height: 30px;
      width: 30px;
      color: #ffffff;
      border-radius: 50%;
      margin: 0 auto;
      line-height: 30px;
    }
    .el-icon-user {
      background-color: #7c7c7c;
    }
    .el-icon-files {
      background-color: #303133;
    }

    @include respond-above(md) {
      display: none;
    }
  }

  @include respond-below(md) {
    position: fixed;
    bottom: 0;
    z-index: 1000;
    width: calc(100% - 30px);
    padding: 0;
    margin: 15px;
    background-color: #f4b452;
    height: 48px;
    border-radius: 21px;
    box-shadow: 0 2px 12px 0 rgba(157, 157, 157, 0.5);
    justify-content: space-evenly;

    a {
      color: #000000;
    }
    a:hover,
    a:focus {
      color: #000000;
    }
  }
}
</style>
